import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '@zapier/design-system';
const focusStyles = css({
    outline: 'none',
    '&::before': {
        content: '""',
        position: 'absolute',
        pointerEvents: 'none',
        top: '-6px',
        right: '-6px',
        bottom: '-6px',
        left: '-6px',
        border: `3px solid ${Colors.zapier}`,
        borderRadius: '31px',
    },
    '&[data-variant="primary-alt"]': {
        '&::before': {
            borderColor: Colors.earth,
        },
    },
    '&[data-variant="secondary"]': {
        '&::before': {
            borderColor: Colors.earth,
        },
    },
});
const Styles = labelStyles('CustomBrandButton', {
    root: css({
        minWidth: '272px',
        height: '50px',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px',
        position: 'relative',
        padding: '8px 20px',
        boxSizing: 'border-box',
        fontFamily: Typography.base.fontFamily,
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: 1.5,
        textDecoration: 'none',
        color: Colors.neutral100,
        backgroundColor: Colors.zapier,
        border: `1px solid ${Colors.zapier}`,
        borderRadius: '25px',
        transition: 'background-color 250ms, border-color 250ms',
        '&[data-size="small"]': {
            minWidth: 'auto',
            height: '44px',
        },
        '&[data-variant="primary-alt"]': {
            backgroundColor: Colors.earth,
            color: Colors.neutral100,
            borderColor: Colors.earth,
        },
        '&[data-variant="secondary"]': {
            backgroundColor: Colors.neutral100,
            color: Colors.earth,
            borderColor: Colors.earth,
        },
        '&:hover:not([disabled]), &:active:not([disabled])': {
            backgroundColor: '#D24304',
            borderColor: '#D24304',
            '&[data-variant="primary-alt"]': {
                backgroundColor: Colors.night,
                borderColor: Colors.night,
            },
            '&[data-variant="secondary"]': {
                backgroundColor: Colors.neutral100,
                borderColor: Colors.earth,
                borderWidth: '2px',
            },
        },
        '&:focus-visible:not(:active)': focusStyles,
        // For browsers that don't support :focus-visible, apply focus styles
        '@supports not selector(:focus-visible)': {
            '&:focus:not(:active)': focusStyles,
        },
    }),
});
export function CustomBrandButton(props) {
    return (_jsx("a", Object.assign({ css: Styles.root, href: props.href, "data-variant": props.variant, "data-size": props.size, onClick: props.onClick }, { children: props.children })));
}
//# sourceMappingURL=CustomBrandButton.js.map